import React, { useEffect, useRef, useState } from "react";
import {
  IoIosArrowForward,
  IoIosCheckmark,
  IoMdArrowRoundBack,
  IoMdArrowRoundForward,
} from "react-icons/io";
import Select from "react-select";
import {
  ChangeTitle,
  decrypt,
  getEncodedCookie,
  selectFormStyle,
  selectStyle,
  selectStyle3,
  toAbsoluteUrl,
  toasterrormsg,
  toastsuccessmsg,
} from "../../helpers/Reusable";
import { Link, useNavigate } from "react-router-dom";
import { IoClose } from "react-icons/io5";
import Slider from "react-slick";
import { BiMinus } from "react-icons/bi";
import { BsPlusLg } from "react-icons/bs";
import { Disclosure } from "@headlessui/react";
import { apiHeader, getData, postData } from "../../helpers/ApiHelper";
import * as Yup from "yup";
import { useFormik } from "formik";
import ClipLoader from "react-spinners/ClipLoader";
import { ToastContainer } from "react-toastify";
import { getCookie, setCookie } from "../../helpers/CookieComponent";

const onlyIntRegExp = /^[0-9+]+$/;
const onlyAlphabet = /^[A-Za-z][A-Za-z\s]+$/;

// Formik InitialValues
const initialValuesConnect = {
  firstName: "",
  lastName: "",
  mobileNumber: "",
  emailId: "",
  pincode: "",
  productType: "",
  message: "",
};
const initialValuesContact = {
  contactNumber: "",
  emailId: "",
};

// Fromik Validation Schema
const schemaConnect = Yup.object().shape({
  firstName: Yup.string()
    .trim()
    .required("First name is required")
    .matches(onlyAlphabet, "First name is not valid"),
  lastName: Yup.string()
    .trim()
    .required("Last name is required")
    .matches(onlyAlphabet, "Last name is not valid"),
  mobileNumber: Yup.string()
    .trim()
    .required("Mobile number is required")
    .matches(onlyIntRegExp, "Mobile number is not valid")
    .min(10, "Mobile number is not valid")
    .max(16, "Mobile number is not valid"),
  emailId: Yup.string()
    .trim()
    .required("Email is required")
    .matches(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      "Email is not valid"
    ),
  pincode: Yup.string()
    .trim()
    .required("Pin code is required")
    .matches(onlyIntRegExp, "Pin code is not valid"),
  productType: Yup.string().trim().required("Select product type"),
  message: Yup.string().trim().required("Message is required"),
});
const schemaContact = Yup.object().shape({
  contactNumber: Yup.string()
    .trim()
    .required("Contact number is required")
    .matches(onlyIntRegExp, "Contact number is not valid")
    .min(10, "Contact number is not valid")
    .max(16, "Contact number is not valid"),
  emailId: Yup.string()
    .trim()
    .required("Email is required")
    .matches(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      "Email is not valid"
    ),
});

const ReadyReference = () => {
  ChangeTitle("ReadyReference");
  const [mainMenu, setMainMenu] = useState("Combo");
  const [selectedMenu, setSelectedMenu] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState("INR");
  const [selectedCountry, setSelectedCountry] = useState("");
  const [currencySymbol, setCurrencySymbol] = useState("₹");
  const [currencyList, setCurrencyList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [filterPlanList, setFilterPlanList] = useState([]);
  const [loadingConnect, setLoadingConnect] = useState(false);
  const [loadingContact, setLoadingContact] = useState(false);
  const [productTypeList, setProductTypeList] = useState([]);
  const [faqsList, setFaqsList] = useState([]);
  const navigate = useNavigate();
  const [openIndex, setOpenIndex] = useState(null); // State to track which accordion is open
  const auth = decrypt(getCookie("token")) || "";

  console.log("counrty", countryList);

  // Accordion open verify function
  const isOpen = (index) => openIndex === index;

  // Accordion toggle function
  const toggleAccordion = (index) => {
    setOpenIndex((prevIndex) => (prevIndex === index ? -1 : index)); // Toggle or close the accordion
  };

  const formikConnect = useFormik({
    initialValues: initialValuesConnect,
    validationSchema: schemaConnect,
    onSubmit: async (values, { resetForm }) => {
      setLoadingConnect(true);

      const param = {
        firstName: values.firstName,
        lastName: values.lastName,
        mobileNumber: values.mobileNumber,
        email: values.emailId,
        pincode: values.pincode,
        productTypeId: values.productType,
        message: values.message,
      };

      const response = await postData(
        "readyrefernceconnect/add/detail",
        param,
        apiHeader(false)
      );

      if (
        String(response?.status) == "200" &&
        String(response?.data.status) == "200"
      ) {
        toastsuccessmsg(response.data.message);
        setTimeout(() => {
          setLoadingConnect(false);
          resetForm();
        }, 1500);
      } else {
        console.log(response.data.message);
        toasterrormsg(response.data.message);
        setLoadingConnect(false);
      }
    },
  });

  const formikContact = useFormik({
    initialValues: initialValuesContact,
    validationSchema: schemaContact,
    onSubmit: async (values, { resetForm }) => {
      setLoadingContact(true);

      const param = {
        contactNumber: values.contactNumber,
        email: values.emailId,
      };

      const response = await postData(
        "enterpricedetail/add/detail",
        param,
        apiHeader(false)
      );

      if (
        String(response?.status) == "200" &&
        String(response?.data.status) == "200"
      ) {
        toastsuccessmsg(response.data.message);
        setTimeout(() => {
          closeModal();
          setLoadingContact(false);
          resetForm();
        }, 1500);
      } else {
        console.log(response.data.message);
        toasterrormsg(response.data.message);
        setLoadingContact(false);
      }
    },
  });

  const openModal = () => {
    document.body.style.overflowY = "hidden";
    setIsModalOpen(true);
  };
  const closeModal = () => {
    document.body.style.overflowY = "";
    setIsModalOpen(false);
    formikContact.resetForm();
  };

  // Product Type List API Call
  const viewProductTypeList = async () => {
    const param = {};
    var response = await postData("producttype/list", param, apiHeader(false));

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      const listData = data.map((data) => {
        return {
          value: data._id,
          label: data.productTypeName,
        };
      });
      setProductTypeList(listData);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  // Currency API Call
  const viewCurrencyList = async () => {
    const param = {};
    // var response = await postData("country/list", param, apiHeader(false));
    var response = await postData("currency/list", param, apiHeader(false));

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      const currencyData = data.map((data) => {
        return {
          id: data._id,
          value: data.countryDetail.currency,
          label: `${data.countryDetail.currencyName} (${data.countryDetail.currencySymbol}) - ${data.countryDetail.currency}`,
          currencySymbol: data.countryDetail.currencySymbol,
          currency: data.countryDetail.currency,
        };
      });
      setCurrencyList(currencyData);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };
  // Country API Call
  const viewCountryList = async () => {
    const param = {};
    // var response = await postData("country/list", param, apiHeader(false));
    var response = await getData(
      "private/country/list",
      param,
      apiHeader(false)
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      const listData = data.map((data) => {
        return {
          value: data._id,
          label: data.countryName,
        };
      });
      setCountryList(listData);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  useEffect(() => {
    viewCountryList();
  }, []);

  // Faqs API Call
  const viewFaqsList = async () => {
    const param = {
      type: "readyReference",
    };
    var response = await postData("faq/list", param, apiHeader(false));

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      const faqsData = data.map((data) => {
        return {
          id: data._id,
          question: data.question,
          answer: data.answer,
        };
      });
      setFaqsList(faqsData);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  useEffect(() => {
    viewFaqsList();
    viewCurrencyList();
    viewProductTypeList();
    setCookie("rr-plan-currency", "INR", {});
  }, []);

  // Plans API Call
  const viewFilterPlanList = async (type, currency, countryId = "") => {
    const param = {
      type: String(type),
      currency: String(currency),
    };
    if (countryId) {
      param.countryId = String(countryId);
    }

    var response = await postData(
      "readyreferenceplan/user/list",
      param,
      apiHeader(false)
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      const filterPlanListData = data.map((data) => {
        return {
          id: data._id,
          price: data.price.toFixed(2),
          currency: data.defaultCurrency,
          name: data.name,
          description: data.description,
          services: data.services,
          type: data.type,
          planTypeName: data.planTypeName,
          taxservice: data.taxservice && data.taxservice.serviceName,
          country: data.country && data.country.countryName,
        };
      });
      setFilterPlanList(filterPlanListData);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  // useEffect(() => {
  //   viewFilterPlanList(mainMenu, selectedCurrency);
  // }, [mainMenu, selectedCurrency]);
  useEffect(() => {
  viewFilterPlanList(mainMenu, selectedCurrency, selectedCountry);
}, [mainMenu, selectedCurrency, selectedCountry]);

  // Plan Buy Function
  const buyPlan = async (data, type) => {
    setCookie("rr-planbillingId", data.id, {});
    setCookie("rr-plan-type", type, {});

    const param = {
      planId: data.id,
      type: type,
      promoCode: "",
      currency: data.currency || "INR",
    };
    var response = await postData(
      "private/readyreferenceplanpurchase/preview",
      param,
      apiHeader(false)
    );

    console.log("rr plan detail billing", response);

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      navigate("/readyreference/billing");
    } else {
      toasterrormsg(response.data.message);
    }
  };

  // Slider Setting
  const rrSetting2 = {
    slidesPerRow: 1,
    slidesToShow: 5,
    slidesToScroll: 1,
    infinite: false,
    swipeToSlide: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          // speed: 2000,
          // autoplay: true,
          // autoplaySpeed: 1,
        },
      },
      {
        breakpoint: 976,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const rrSetting = {
    slidesPerRow: 1,
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: false,
    swipeToSlide: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          // speed: 2000,
          // autoplay: true,
          // autoplaySpeed: 1,
        },
      },
      {
        breakpoint: 976,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <>
      <ToastContainer />
      {isModalOpen === true && (
        <>
          <div
            onClick={closeModal}
            className="w-full fixed top-0 z-[9999] h-screen overflow-x-hidden overflow-y-auto bg-form"
          >
            <div
              onClick={(e) => e.stopPropagation()}
              className="w-[90%] md:w-[80%] lg:w-[70%] xl:w-[60%] xxl:container p-[2%] mx-auto my-[5%] lg:my-0 relative lg:top-[15%] xl:top-1/2 transform xl:-translate-y-1/2 form-box"
            >
              <div className="flex items-center justify-between">
                <h1 className="mb-[3%] hanson">Get in touch</h1>
                <IoClose
                  onClick={closeModal}
                  className="w-[3rem] h-[3rem] cursor-pointer"
                />
              </div>
              <div className="">
                <form onSubmit={formikContact.handleSubmit}>
                  <div className="w-full grid lg:grid-cols-2 gap-[2rem] gap-y-[1rem] mb-[2rem]">
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Contact number
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter contact number"
                        id="contactNumber"
                        value={formikContact.values.contactNumber}
                        onChange={formikContact.handleChange}
                      />
                      {formikContact.touched.contactNumber &&
                        formikContact.errors.contactNumber && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikContact.errors.contactNumber}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Email id
                      </label>
                      <input
                        className="w-full form-input"
                        type="email"
                        placeholder="Enter email id"
                        id="emailId"
                        value={formikContact.values.emailId}
                        onChange={formikContact.handleChange}
                      />
                      {formikContact.touched.emailId &&
                        formikContact.errors.emailId && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikContact.errors.emailId}
                            </div>
                          </div>
                        )}
                    </div>
                  </div>
                  <div className="w-full justify-center gap-5 flex">
                    <button
                      type="submit"
                      className="btn-submit"
                      disabled={loadingContact}
                    >
                      {!loadingContact && <>Submit</>}
                      {loadingContact && (
                        <div className="flex items-center gap-3">
                          <span className="" style={{ display: "block" }}>
                            Please wait...{" "}
                          </span>
                          <ClipLoader
                            color={"#ffffff"}
                            loading={loadingContact}
                            size={20}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                          />
                        </div>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </>
      )}
      <div className="relative w-full h-auto px-[5%] py-[5%] lg:py-[2%] bg-light-yellow">
        <div className="xxl:container mx-auto">
          <div className="mb-[3rem]">
            <h1 className="mb-[1rem] rrd-title">
              Ready referencer is a comprehensive platform for GCC tax law
              research. Here’s a simple breakdown of its features:
            </h1>
            <ul className="pl-[3rem] lg:pl-[5rem] rrd-ul">
              <li className="rrd-ul-li">
                Powerful search engine -{" "}
                <span className="rrd-ul-li-span">
                  Helps you find information quickly and efficiently.
                </span>
              </li>
              <li className="rrd-ul-li">
                Smart integration -{" "}
                <span className="rrd-ul-li-span">
                  Seamlessly connects different tools and resources.
                </span>
              </li>
              <li className="rrd-ul-li">
                Always-amended statutes -{" "}
                <span className="rrd-ul-li-span">
                  Ensures you have access to the most current laws.
                </span>
              </li>
            </ul>
          </div>
          <div className="w-[90%] mx-auto grid grid-cols-1 md:grid-cols-2 md:gap-20 mb-[-2%]">
            <div className="flex relative z-[3] mb-[2rem] justify-center items-center gap-5">
              <label className="w-max currencylabel">Currency</label>
              <div className="w-[80%] currencyselect">
                <Select
                  name="currenyName"
                  id="currencyName"
                  placeholder="Select Currency"
                  className="w-full cs-main"
                  isSearchable={true}
                  options={currencyList}
                  value={currencyList.find(
                    (item) => item.value === selectedCurrency
                  )}
                  onChange={(e) => {
                    setSelectedCurrency(e.value);
                    setCurrencySymbol(e.currency);
                    setCookie("rr-plan-currency", e.currency, {});
                  }}
                  // styles={selectStyle}
                  styles={{
                    ...selectStyle3,
                    menuPortal: (base) => ({ ...base, zIndex: 99 }),
                  }}
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                />
              </div>
            </div>
            <div className="flex relative z-[3] mb-[2rem] justify-center items-center gap-5">
              <label className="w-max currencylabel">Country</label>
              <div className="w-[80%] currencyselect">
                <Select
                  name="countryName"
                  id="countryName"
                  placeholder="Select Country"
                  className="w-full cs-main"
                  isSearchable={true}
                  options={countryList}
                  value={countryList.find(
                    (item) => item.value === selectedCountry
                  )}
                  onChange={(e) => {
                    setSelectedCountry(e.value);
                  }}
                  styles={{
                    ...selectStyle3,
                    menuPortal: (base) => ({ ...base, zIndex: 99 }),
                  }}
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                />
              </div>
            </div>
          </div>
          <div className="relative z-[2] top-[3vw] w-full md:w-[80%] lg:w-[50%] flex justify-evenly py-[2%] mx-auto rr-main-menu">
            <Link
              className={
                mainMenu === "Combo" ? "rrmm-box-active rrmm-box" : "rrmm-box"
              }
              onClick={() => setMainMenu("Combo")}
            >
              Combo
            </Link>
            <Link
              className={
                mainMenu === "Individual"
                  ? "rrmm-box-active rrmm-box"
                  : "rrmm-box"
              }
              onClick={() => setMainMenu("Individual")}
            >
              Individual
            </Link>
            <Link
              className={
                mainMenu === "Country Wise"
                  ? "rrmm-box-active rrmm-box"
                  : "rrmm-box"
              }
              onClick={() => setMainMenu("Country Wise")}
            >
              Country wise
            </Link>
            <Link
              className={
                mainMenu === "Enterprise"
                  ? "rrmm-box-active rrmm-box"
                  : "rrmm-box"
              }
              onClick={() => setMainMenu("Enterprise")}
            >
              Enterprise
            </Link>
          </div>
          {mainMenu && mainMenu == "Combo" && (
            <div className="relative z-[1] mb-[5%] w-[90%] flex mx-auto px-[3%] pb-[5%] pt-[7%] rr-combo-box">
              <div className="w-full">
                {filterPlanList.length > 0 && (
                  <Slider
                    className="w-full mx-auto cursor-pointer flex gap-10 relative z-[1] hp1-part2-imgs rr-box"
                    {...rrSetting}
                  >
                    {filterPlanList.map((data) => (
                      <section className="relative z-[10] w-full h-full md:px-[10%] flex flex-col justify-between rrcb-main">
                        <section className="">
                          <h1 className="w-full text-center py-[5%] hanson">
                            {data.name}
                          </h1>
                          <h2 className="text-center py-[5%]  rrcbprice">
                            {selectedCurrency} {data.price}
                          </h2>
                          {data.services &&
                            data.services.map((data) => (
                              <section className="w-full mb-[8%] flex gap-5 rrcbpoint">
                                <IoIosCheckmark className="items-center rrcbtick" />
                                <h3 className="leading-none w-[80%]">
                                  {data.serviceName}
                                </h3>
                              </section>
                            ))}
                        </section>
                        <section className="w-full rrcb-btn">
                          <button
                            onClick={() => {
                              if (!auth) {
                                toasterrormsg("Please login first");
                                return false;
                              }

                              buyPlan(data, mainMenu);
                            }}
                            className="py-[5%] w-full btn-choose-plan"
                          >
                            Choose plan
                          </button>
                        </section>
                      </section>
                    ))}
                  </Slider>
                )}
                {filterPlanList.length == 0 && (
                  <>
                    <h1 className="text-center not-exist-msg">No data found</h1>
                  </>
                )}
              </div>
            </div>
          )}
          {mainMenu && mainMenu == "Individual" && (
            <div className="relative z-[1] mb-[5%] w-[90%] flex mx-auto px-[3%] pb-[5%] pt-[7%] rr-combo-box rr-individual-box">
              <div className="w-full">
                {filterPlanList.length > 0 && (
                  <Slider
                    className="w-full mx-auto cursor-pointer flex gap-10 relative z-[1] hp1-part2-imgs rr-box"
                    {...rrSetting2}
                  >
                    {filterPlanList.map((data) => (
                      <section className="w-full flex flex-col justify-between h-full  md:px-[10%] rrcb-main rrcwb-main">
                        <section className="">
                          <h2 className="text-center py-[5%] mb-[5%] rribprice">
                            {selectedCurrency} {data.price}
                          </h2>
                          <h3 className="mb-[10%] rribtitle">
                            {data.taxservice}
                          </h3>
                        </section>
                        <section className="w-full rrcb-btn">
                          <button
                            onClick={() => {
                              if (!auth) {
                                toasterrormsg("Please login first");
                                return false;
                              }

                              buyPlan(data, mainMenu);
                            }}
                            className="py-[5%] w-full btn-choose-plan"
                          >
                            Choose plan
                          </button>
                        </section>
                      </section>
                    ))}
                  </Slider>
                )}
                {filterPlanList.length == 0 && (
                  <>
                    <h1 className="text-center not-exist-msg">No data found</h1>
                  </>
                )}
              </div>
            </div>
          )}
          {mainMenu && mainMenu == "Country Wise" && (
            <div className="relative z-[1] mb-[5%] w-[90%] flex mx-auto px-[3%] pb-[5%] pt-[7%] rr-combo-box rr-individual-box rr-countrywise-box">
              <div className="w-full">
                {filterPlanList.length > 0 && (
                  <Slider
                    className="w-full mx-auto cursor-pointer flex gap-10 relative z-[1] hp1-part2-imgs rr-box"
                    {...rrSetting}
                  >
                    {filterPlanList.map((data) => (
                      <section className="w-full flex flex-col justify-between h-full md:px-[10%] rrcb-main rrcwb-main">
                        <section className="">
                          <h2 className="text-center py-[5%] mb-[5%] rribprice">
                            {selectedCurrency} {data.price}
                          </h2>
                          <h3 className="mb-[10%] text-center rribtitle">
                            {data.country}
                          </h3>
                        </section>
                        <section className="w-full rrcb-btn">
                          <button
                            onClick={() => {
                              if (!auth) {
                                toasterrormsg("Please login first");
                                return false;
                              }
                              buyPlan(data, mainMenu);
                            }}
                            className="py-[5%] w-full btn-choose-plan"
                          >
                            Choose plan
                          </button>
                        </section>
                      </section>
                    ))}
                  </Slider>
                )}
                {filterPlanList.length == 0 && (
                  <>
                    <h1 className="text-center not-exist-msg">No data found</h1>
                  </>
                )}
              </div>
            </div>
          )}
          {mainMenu && mainMenu == "Enterprise" && (
            <div className="relative z-[1] mb-[5%] w-[90%] flex mx-auto px-[3%] pb-[5%] pt-[7%] rr-combo-box rr-individual-box rr-countrywise-box rr-enterprise-box">
              <div className="md:w-[70%] mx-auto">
                <h1 className="text-center mb-[5%] rreb-title">
                  For enterprises solutions, please submit your contact number
                  and email id so that our sales team can connect with you.
                </h1>
                <div className="w-full flex justify-center rrcb-btn">
                  <button
                    onClick={() => openModal()}
                    className="mx-auto py-[2%] w-[50%] md:w-[30%] btn-choose-plan"
                  >
                    Contact us
                  </button>
                </div>
              </div>
            </div>
          )}
          <div className="md:w-[90%] p-[3%] mb-[5%] mx-auto rr-form">
            <div className="flex items-center justify-between">
              <h1 className="mb-[3%] rr-form-h1 hanson">Let us connect</h1>
            </div>
            <form action="" onSubmit={formikConnect.handleSubmit}>
              <div className="w-full grid lg:grid-cols-2 gap-[2rem] mb-[4rem]">
                <div className="w-full flex flex-col">
                  <label
                    htmlFor=""
                    className="w-full form-input-label required mb-4"
                  >
                    First name
                  </label>
                  <input
                    className="w-full form-input"
                    type="text"
                    placeholder="Enter first name"
                    id="firstName"
                    value={formikConnect.values.firstName}
                    onChange={formikConnect.handleChange}
                  />
                  {formikConnect.touched.firstName &&
                    formikConnect.errors.firstName && (
                      <div className="mt-4 error-msg">
                        <div className="">{formikConnect.errors.firstName}</div>
                      </div>
                    )}
                </div>
                <div className="w-full flex flex-col">
                  <label
                    htmlFor=""
                    className="w-full form-input-label required mb-4"
                  >
                    Last name
                  </label>
                  <input
                    className="w-full form-input"
                    type="text"
                    placeholder="Enter last name"
                    id="lastName"
                    value={formikConnect.values.lastName}
                    onChange={formikConnect.handleChange}
                  />
                  {formikConnect.touched.lastName &&
                    formikConnect.errors.lastName && (
                      <div className="mt-4 error-msg">
                        <div className="">{formikConnect.errors.lastName}</div>
                      </div>
                    )}
                </div>{" "}
                <div className="w-full flex flex-col">
                  <label
                    htmlFor=""
                    className="w-full form-input-label required mb-4"
                  >
                    Mobile number
                  </label>
                  <input
                    className="w-full form-input"
                    type="text"
                    placeholder="Enter mobile number"
                    id="mobileNumber"
                    value={formikConnect.values.mobileNumber}
                    onChange={formikConnect.handleChange}
                  />
                  {formikConnect.touched.mobileNumber &&
                    formikConnect.errors.mobileNumber && (
                      <div className="mt-2 error-msg">
                        <div className="">
                          {formikConnect.errors.mobileNumber}
                        </div>
                      </div>
                    )}
                </div>
                <div className="w-full flex flex-col">
                  <label
                    htmlFor=""
                    className="w-full form-input-label required mb-4"
                  >
                    Email id
                  </label>
                  <input
                    className="w-full form-input"
                    type="email"
                    placeholder="Enter email id"
                    id="emailId"
                    value={formikConnect.values.emailId}
                    onChange={formikConnect.handleChange}
                  />
                  {formikConnect.touched.emailId &&
                    formikConnect.errors.emailId && (
                      <div className="mt-2 error-msg">
                        <div className="">{formikConnect.errors.emailId}</div>
                      </div>
                    )}
                </div>
                <div className="w-full flex flex-col">
                  <label
                    htmlFor=""
                    className="w-full form-input-label required mb-4"
                  >
                    Pin code
                  </label>
                  <input
                    className="w-full form-input"
                    type="text"
                    placeholder="Enter pin code"
                    id="pincode"
                    value={formikConnect.values.pincode}
                    onChange={formikConnect.handleChange}
                  />
                  {formikConnect.touched.pincode &&
                    formikConnect.errors.pincode && (
                      <div className="mt-2 error-msg">
                        <div className="">{formikConnect.errors.pincode}</div>
                      </div>
                    )}
                </div>
                <div className="w-full flex flex-col">
                  <label
                    htmlFor=""
                    className="w-full form-input-label required mb-4"
                  >
                    Product type
                  </label>
                  <Select
                    name="productType"
                    id="productType"
                    placeholder="Select product type"
                    className="w-full form-select form-input"
                    isSearchable={true}
                    options={productTypeList}
                    value={
                      formikConnect.values.productType &&
                      productTypeList.find(
                        (item) =>
                          item.value === formikConnect.values.productType
                      )
                    }
                    onChange={(e) =>
                      formikConnect.setFieldValue("productType", e.value)
                    }
                    styles={selectFormStyle}
                  />
                  {formikConnect.touched.productType &&
                    formikConnect.errors.productType && (
                      <div className="mt-2 error-msg">
                        <div className="">
                          {formikConnect.errors.productType}
                        </div>
                      </div>
                    )}
                </div>
                <div className="w-full flex flex-col">
                  <label
                    htmlFor=""
                    className="w-full form-input-label mb-4 required"
                  >
                    Message
                  </label>
                  <textarea
                    placeholder="Enter message"
                    type="text"
                    className="w-full form-input"
                    id="message"
                    value={formikConnect.values.message}
                    onChange={formikConnect.handleChange}
                    rows={3}
                  />
                  {formikConnect.touched.message &&
                    formikConnect.errors.message && (
                      <div className="mt-4 error-msg">
                        <div className="">{formikConnect.errors.message}</div>
                      </div>
                    )}
                </div>
              </div>
              <div className="w-full justify-center gap-5 flex">
                <button
                  type="submit"
                  className="btn-submit"
                  disabled={loadingConnect}
                >
                  {!loadingConnect && <>Submit</>}
                  {loadingConnect && (
                    <div className="flex items-center gap-3">
                      <span className="" style={{ display: "block" }}>
                        Please wait...{" "}
                      </span>
                      <ClipLoader
                        color={"#ffffff"}
                        loading={loadingConnect}
                        size={20}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                      />
                    </div>
                  )}
                </button>
              </div>
            </form>
          </div>
          <div className="w-full faqs">
            <div className="w-full">
              <h1 className="hanson text-center mb-[1%] ap6-h1">FAQ’s</h1>
              <img
                className="mb-[2%] mx-auto"
                src={toAbsoluteUrl("media/img/titledesign/t-yellow.svg")}
                alt=""
              />
            </div>
            <div className="w-full md:w-[90%] mx-auto flex flex-col gap-5 mb-[5%] faqs">
              {faqsList.map((data, index) => (
                <div
                  key={index}
                  className={
                    isOpen(index) ? "p-[2%] faqs-box-active" : "p-[2%] faqs-box"
                  }
                >
                  <button
                    onClick={() => toggleAccordion(index)}
                    className="flex w-full !text-start justify-between"
                  >
                    <span>{data.question}</span>
                    {isOpen(index) ? (
                      <BiMinus className="faqs-minus" />
                    ) : (
                      <BsPlusLg className="faqs-plus" />
                    )}
                  </button>
                  {isOpen(index) && (
                    <div className="px-4 pb-2 pt-4 text-sm text-gray-500">
                      <p
                        className=""
                        dangerouslySetInnerHTML={{ __html: data.answer }}
                      />
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReadyReference;
